export default __webpack_public_path__ + "static/media/KOD0039-min.ad4f19de.webp";